import React from 'react';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import CommentIcon from '../../../Icons/Comment';
import Who from '../../../Who';
import { SplitStatLayout } from '../StatLayout';
import { getCommentBoxId } from '../../../CommentThread/helpers';
import { getCommentableTypeForDeviationType } from '../../../DeviationPage/redux/helpers';
import { hasUserLists } from '../../helpers';
import { BiLoggerContextProvider, BiEventType } from '../../../biLogger';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
export var CommentStat = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var spacingExperiment = useFlag('actionbar_spacing');
    var editorId = getCommentBoxId(getCommentableTypeForDeviationType(deviation.typeId), deviation.deviationId, 'top');
    var hasPopover = hasUserLists(deviation);
    var isExtendedLoaded = !!deviation.extended;
    return (React.createElement(SplitStatLayout, { icon: CommentIcon, tooltip: {
            tooltipKey: deviation.isCommentable || !spacingExperiment
                ? 'actionbar.comment'
                : 'actionbar.comment.disabled',
            renderPopover: hasPopover
                ? function () { return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'comments_pop_up' } },
                    React.createElement(Who, { deviation: deviation, userListType: "comment", headline: t('actionbar.users.who.commented') }))); }
                : undefined,
            positionOnly: true,
        }, onClick: function () { return isExtendedLoaded && onClick(editorId, true); }, biEventData: {
            evid: BiEventType.THUMB_CLICK_COMMENT,
            typeid: getDeviationResourceType(deviation),
            creatorid: deviation.author ? deviation.author.useridUuid : undefined,
            itemid: deviation.deviationId,
        }, value: get(deviation, 'stats.comments'), isDisabled: !deviation.isCommentable, hasValue: true }));
};
CommentStat.displayName = 'CommentStat';
export default CommentStat;
//# sourceMappingURL=CommentStat.js.map